export default {
  getImage(image) {
    return require(`@/${image}`);
  }
}
